import Api from '../../api/api'
import jwt_decode from 'jwt-decode'

export default {
  namespaced: true,
  state: {
    token: undefined,
    profileLoaded: false,
    profile: {
      first_name: null,
      last_name: null,
      mobile: null,
      email: null,
      address: null,
      picture: null,
      user_picture: {
        thumb_url: null,
        url: null
      },
      zip: null,
      city: null,
      country: null,
      gender: null,
      account_id: null
    }
  },
  getters: {
    isLoggedIn({token}) {
      return !!token
    }
  },
  actions: {
    async fetchProfile({ commit }) {
      const response = await Api.get('/2.6/members/me', {tokenAuth: true})

      commit('SET_PROFILE', response.data)
    },
    save({ commit }, profile) {
      commit('SET_PROFILE', profile)

      let formData = new FormData()
      formData.set('profile[first_name]', profile.first_name);
      formData.set('profile[last_name]', profile.last_name);
      formData.set('profile[mobile]', profile.mobile);
      formData.set('profile[email]', profile.email);
      formData.set('profile[gender]', profile.gender);
      formData.set('profile[street]', profile.street);
      formData.set('profile[house_number]', profile.house_number);
      formData.set('profile[house_number_suffix]', profile.house_number_suffix);
      formData.set('profile[zip]', profile.zip);
      formData.set('profile[city]', profile.city);
      formData.set('profile[country]', profile.country);
      formData.set('profile[birthday]', profile.birthday);
      profile.opt_ins.forEach((opt_in) => {
        formData.append('profile[opt_ins][]', opt_in);
      })
      if (profile.opt_ins.length == 0) {
        formData.append('profile[remove_opt_ins]', true);
      }

      if(profile.picture?.new) {
        formData.set('profile[picture]', profile.picture.fileList[0]);
      } else if(profile.picture?.delete) {
        formData.set('profile[remove_picture]', true);
      }

      return Api.put('/2.0/members/me', formData, {
        tokenAuth: true,
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    }
  },
  mutations: {
    SET_PROFILE(state, profile){
      state.profileLoaded = true
      state.profile = profile
    },
    USER_TOKEN_SET(state, token) {
      state.token = token
      if (token) {
        const {first_name, uid, email, phone_number: mobile} = jwt_decode(token)
        state.profile.email = email
        state.profile.first_name = first_name
        state.profile.account_id = uid
        state.profile.mobile = mobile
      }
    }
  }
}
